import { Link } from "react-router-dom";
import { useTestimonials, useProjects, useProducts } from "@/hooks/useData";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Eyebrow } from "@/components/Reveal";
import { MessageSquareQuote, FolderKanban, Sofa, Inbox } from "lucide-react";

export default function Dashboard() {
  const { data: testimonials = [] } = useTestimonials();
  const { data: projects = [] } = useProjects();
  const { data: products = [] } = useProducts();
  const { data: inquiries = [] } = useQuery({ queryKey: ["admin-inquiries"], queryFn: async () => (await api.get("/admin/inquiries")).data });

  const cards = [
    { l: "Testimonials", v: testimonials.length, to: "/admin/testimonials", icon: MessageSquareQuote },
    { l: "Projects", v: projects.length, to: "/admin/projects", icon: FolderKanban },
    { l: "Products", v: products.length, to: "/admin/products", icon: Sofa },
    { l: "Inquiries", v: inquiries.length, to: "/admin/inquiries", icon: Inbox },
  ];

  return (
    <div data-testid="admin-dashboard">
      <Eyebrow>Overview</Eyebrow>
      <h1 className="font-display text-4xl font-medium text-[#2C2A29] mt-2 mb-10">Dashboard</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link key={c.l} to={c.to} className="bg-white border border-[#ECEAE4] p-6 hover:border-[#9E8773] transition-colors group" data-testid={`dashboard-card-${c.l.toLowerCase()}`}>
            <c.icon size={22} className="text-[#9E8773]" strokeWidth={1.5} />
            <div className="font-display text-5xl font-medium text-[#2C2A29] mt-4">{c.v}</div>
            <div className="label-eyebrow text-[10px] text-[#5E5A54] mt-1 group-hover:text-[#9E8773]">{c.l}</div>
          </Link>
        ))}
      </div>

      <div className="mt-12 bg-white border border-[#ECEAE4]">
        <div className="px-6 py-4 border-b border-[#ECEAE4] flex justify-between items-center">
          <h2 className="font-display text-2xl font-medium text-[#2C2A29]">Recent Inquiries</h2>
          <Link to="/admin/inquiries" className="label-eyebrow text-[10px] text-[#9E8773]">View all →</Link>
        </div>
        {inquiries.length === 0 ? (
          <p className="p-6 text-[#5E5A54] font-light">No inquiries yet.</p>
        ) : (
          <ul className="divide-y divide-[#ECEAE4]">
            {inquiries.slice(0, 6).map((q) => (
              <li key={q.id} className="px-6 py-4 flex justify-between gap-4">
                <div>
                  <p className="text-[#2C2A29] font-medium">{q.name || "—"} <span className="label-eyebrow text-[9px] text-[#9E8773] ml-2">{q.type}</span></p>
                  <p className="text-sm text-[#5E5A54] font-light">{q.email} {q.product_name ? `· ${q.product_name}` : ""}</p>
                </div>
                <span className="text-xs text-[#9E8773] whitespace-nowrap">{new Date(q.created_at).toLocaleDateString()}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
